export default {"src":"/_next/static/media/arrow_right_alt.c15db488.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};